export async function toBase64 (file: any): Promise<string | undefined> {
  return await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => { resolve(reader.result as any) }
    reader.onerror = reject
  })
}
